function EditIcon() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M2.4989 14.376V17.501H5.6239L14.8406 8.28438L11.7156 5.15938L2.4989 14.376ZM17.2572 5.86771C17.5822 5.54271 17.5822 5.01771 17.2572 4.69271L15.3072 2.74271C14.9822 2.41771 14.4572 2.41771 14.1322 2.74271L12.6072 4.26771L15.7322 7.39271L17.2572 5.86771Z'
        fill='#FF5227'
      />
    </svg>
  );
}

export { EditIcon };
